<!--
  Lite has one scene. New Scene and scene playback open this popover, which points to the full workspace and opens the
  Open in Nanome dialog.
-->
<script setup lang="ts">
import { nextTick, ref } from 'vue';
import Button from 'primevue/button';
import Popover from 'primevue/popover';
import NanomeIcon from '@/components/NanomeIcon.vue';

const emit = defineEmits<{ 'open-in-nanome': [] }>();

const popover = ref<InstanceType<typeof Popover>>();

function open() {
  popover.value?.hide();
  emit('open-in-nanome');
}

/**
 * Opens next to the control that was clicked. A popover that is already open keeps its place when shown again, so it
 * is closed first and reopened on the next tick (WorkspaceScenesPanel.vue toggleMenuActions does the same).
 */
async function show(event: Event, target?: HTMLElement | null) {
  const anchor = target ?? (event.currentTarget as HTMLElement | null) ?? (event.target as HTMLElement | null);
  popover.value?.hide();
  await nextTick();
  popover.value?.show(event, anchor ?? undefined);
}

defineExpose({ show, hide: () => popover.value?.hide() });
</script>

<template>
  <Popover ref="popover" pt:content="w-64 flex flex-col gap-3" data-testid="scenes-teaser">
    <div class="flex items-center gap-2 text-sm font-medium">
      <i class="i-tabler-stack-2" /> Scenes
    </div>
    <p class="m-0 text-sm op-80">
      Multiple scenes, recordings and playback are in the full Nanome workspace.
    </p>
    <Button label="Open in Nanome" size="small" rounded class="self-start" data-testid="scenes-teaser-open" @click="open">
      <template #icon="iconProps">
        <NanomeIcon :class="iconProps.class" />
      </template>
    </Button>
  </Popover>
</template>
